import global$1 from '../internals/global.js';
import setToStringTag$1 from '../internals/set-to-string-tag.js';

var global = global$1;
var setToStringTag = setToStringTag$1; // JSON[@@toStringTag] property
// https://tc39.es/ecma262/#sec-json-@@tostringtag

setToStringTag(global.JSON, 'JSON', true);
